module.exports = __webpack_public_path__ + "b9aaa3a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/service-insurance.svg
// module id = 3098
// module chunks = 17